import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { HardshipCardsService } from '@brightside-web/desktop/feature/hardship';
import { inject } from '@angular/core';
import { ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { HardshipRequiredDocsService } from './hardship-required-docs.service';



export const hardshipDocsGuardCanActivate: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const hardshipCardService = inject(HardshipCardsService);
  const hardshipState = hardshipCardService.currentState();

  switch (hardshipState) {
    case ServiceState.READY:
    case ServiceState.UPLOAD:
    case ServiceState.REVIEW:
    case ServiceState.INITIAL:
      return true;
    default:
      return router.parseUrl('home');
  }
};

export const hardshipDocsGuardCanMatch: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const hardshipCardService = inject(HardshipCardsService);
  const hardshipState = hardshipCardService.currentState();

  switch (hardshipState) {
    case ServiceState.READY:
    case ServiceState.UPLOAD:
    case ServiceState.REVIEW:
    case ServiceState.INITIAL:
      return true;
    default:
      return router.parseUrl('home');
  }
}

export const hardshipBaseGuardCanMatch: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const hardshipCardService = inject(HardshipCardsService);
  const hardshipRequiredDocsService = inject(HardshipRequiredDocsService);
  const hardshipState = hardshipCardService.currentState();

  switch (hardshipState) {
    case ServiceState.UPLOAD:
      return router.parseUrl('/hardship/additional-documents');
    case ServiceState.READY:
    case ServiceState.REVIEW:
      return router.parseUrl('/hardship/review');
    case ServiceState.INITIAL:
      return true;
    default:
      return router.parseUrl('home');
  }
}